window.Intercom = undefined;
window.UE = undefined;
window.userengage = undefined;

if (document.location.hostname.indexOf("localhost") == -1 && document.location.hostname.indexOf("test") == -1){
    window.intercomSettings = {
        app_id: "peo08590"
    };

    !function(){
        var w=window;
        var ic=w.Intercom;
        if(typeof ic==="function")
        {
            ic('reattach_activator');
            ic('update',w.intercomSettings);
        }else
        {
            var d=document;
            var i=function(){
                i.c(arguments);
            };
            i.q=[];
            i.c=function(args){
                i.q.push(args);
            };
            w.Intercom=i;
            var l=function(){
                var s=d.createElement('script');
                s.type='text/javascript';
                s.async=true;
                s.src='https://widget.intercom.io/widget/peo08590';
                var x=d.getElementsByTagName('script')[0];
                x.parentNode.insertBefore(s,x);
            };
            if(w.attachEvent){
                w.attachEvent('onload',l);
            }else{w.addEventListener('load',l,false);}
        }
    }();
}
else{
    console.log("Running non-production chat replacement now");
}


// window.civchat = {
//     apiKey: "vnXFqH",
// };
// (function () {
//     var d=document;
//     var s=d.createElement('script');
//     s.type='text/javascript';
//     s.async=true;
//     s.src='https://smarttask.user.com/widget.js';
//     var x=d.getElementsByTagName('script')[0];
//     x.parentNode.insertBefore(s,x);
// })();

if (document.location.hostname.indexOf("localhost") == -1 && document.location.hostname.indexOf("test") == -1){

    (function(c,l,a,r,i,t,y){
        c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
        t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
        y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
    })(window, document, "clarity", "script", "pt9ghk2985");
}
else {
    console.log("Running non-production microsoft clarity replacement now");
}

